import { 
    sendChatMessage,
    clearChatMessage,
    setSpecialTask,
    setToggleChat,
    setIsLoading,
    setInvoiceDetail
} from "../../../constants/model-reducers/common/chatbot.settings";
import { httpPost } from '../../../utils/api.utils';


export const initialState = {
    responceMessage:[],
    hasSpecialTask: false,
    isOpen: false,
    isLoading: false,
    auditId: 0,
    exceptionId: 0,
    isGenerateSummary: false,
    invoiceId: 0,
    step: null,
    auditRulesMode: null,
    auditRuleIdsCsv: null,
    getInvoiceDetailId: false,
    actionKey: null,
    actionLabel: null
}

export const ChatbotActions = {
    sendMessage: (message, auditDetailsId, auditExceptionId, generateSummary = false, invoiceDetailId = 0, hasOpenInvoice = false) => async (dispatch, getState) => { 

        const state = getState();
        const chatbotState = state.chatbot;

        // current step coming from last API response (nextAction)
        const currentStep = chatbotState.step || null;

        // invoiceId: either explicit param or stored in state
        const effectiveInvoiceId = invoiceDetailId || chatbotState.invoiceId || 0;

        var data =
        {
            "UserMessage": message,
            "AuditDetailsID": auditDetailsId,
            "AuditExceptionID": auditExceptionId,
            "IsGenerateSummary": generateSummary,
            "InvoiceID": effectiveInvoiceId,
            "Step": currentStep,
            "AuditRulesMode": chatbotState.auditRulesMode,
            "AuditRuleIdsCsv": chatbotState.auditRuleIdsCsv,
            "GetInvoiceDetailId": hasOpenInvoice
        };
        dispatch({
            type: setIsLoading,
            payload: true
        });

        var responce = await httpPost('external/chatbot/chat', data);
        
        dispatch({
            type: sendChatMessage,
            payload: responce.answer,
            loading: false,
            auditDetailsId: auditDetailsId,
            auditExceptionId: auditExceptionId,
            isGenerateSummary: false,
            invoiceId: responce.invoiceId || effectiveInvoiceId,
            step: responce.nextAction || null,
            auditRulesMode:
                responce.auditRulesMode !== undefined
                    ? responce.auditRulesMode
                    : chatbotState.auditRulesMode,
            auditRuleIdsCsv:
                responce.auditRuleIdsCsv !== undefined
                    ? responce.auditRuleIdsCsv
                    : chatbotState.auditRuleIdsCsv,
            getInvoiceDetailId: hasOpenInvoice,
            actionIntent: responce.actionIntent || null,
            actionKey: responce.actionKey || null,
            actionLabel: responce.actionLabel || null
        })

        return responce; //THIS makes await dispatch(...) work
    },
    clearMessage: (invoiceAuditDetailsId = 0, exceptionDetailsID = 0, generateSummary = false, invoiceDetailId = 0, hasOpenInvoice = false) => (dispatch, state) => {
        dispatch({
            type: clearChatMessage,
            payload: [],
            auditDetailsId: invoiceAuditDetailsId,
            auditExceptionId: exceptionDetailsID,
            isGenerateSummary: generateSummary,
            invoiceId: hasOpenInvoice ? invoiceDetailId : 0,
            getInvoiceDetailId: hasOpenInvoice,
            step: null
        })
    },
    toggleChat: (isOpen) => (dispatch) => {
        dispatch({
            type: setToggleChat,
            payload: isOpen
        })
    },
    configSpecialTask: (hasSpecialTask, invoiceAuditDetailsId = 0, exceptionDetailsID = 0) => (dispatch, state) => {
        dispatch({
            type: setSpecialTask,
            payload: hasSpecialTask,
            auditDetailsId: invoiceAuditDetailsId,
            auditExceptionId: exceptionDetailsID,
            isGenerateSummary: true
        })
    },
    getInvoiceDetail: (invoiceDetailId, hasOpenInvoice) => (dispatch, state) => {
        dispatch({
            type: setInvoiceDetail,
            payload: invoiceDetailId,
            getInvoiceDetailId: hasOpenInvoice
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch(action.type) {
        case sendChatMessage:
            return {
                ...state,
                responceMessage: action.payload,
                isLoading: action.loading,
                auditId: action.auditDetailsId,
                exceptionId: action.auditExceptionId,
                isGenerateSummary: action.isGenerateSummary,
                invoiceId: action.invoiceId,
                step: action.step || null,
                auditRulesMode: action.auditRulesMode || null,
                auditRuleIdsCsv: action.auditRuleIdsCsv || null,
                getInvoiceDetailId: action.getInvoiceDetailId,
                actionIntent: action.actionIntent,
                actionKey: action.actionKey,
                actionLabel: action.actionLabel
            }
        case clearChatMessage:
            return {
                ...state,
                responceMessage: [],
                auditId: action.auditDetailsId,
                exceptionId: action.auditExceptionId,
                isGenerateSummary: action.isGenerateSummary,
                invoiceId: action.invoiceId,
                step: action.step ?? null,
                auditRulesMode: null,
                auditRuleIdsCsv: null,     
                getInvoiceDetailId: action.getInvoiceDetailId
            }
        case setSpecialTask:
            return {
                ...state,
                hasSpecialTask: action.payload,
                auditId: action.auditDetailsId,
                exceptionId: action.auditExceptionId,
                isGenerateSummary: action.isGenerateSummary
            }
        case setInvoiceDetail:
            return {
                ...state,
                invoiceId: action.payload,
                getInvoiceDetailId: action.getInvoiceDetailId,
                step: action.step !== undefined ? action.step : state.step
            }
        case setToggleChat: 
            return {
                ...state,
                isOpen: action.payload
            }
        case setIsLoading:
            return {
                ...state,
                isLoading: action.payload
            }
        default:
            return state;
    }
}